// extracted by mini-css-extract-plugin
module.exports = {"header":"ProfileInfo_header__3_fPx","personalInfo":"ProfileInfo_personalInfo__OG8JU","inputContainer":"ProfileInfo_inputContainer__afodx","input":"ProfileInfo_input___Ke6_"};